var _path, _path2, _circle, _path3, _path4, _circle2, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdjustmentSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.87805V2.5C19 1.67157 18.3284 1 17.5 1H2.5C1.67157 1 1 1.67157 1 2.5V18.5C1 19.3284 1.66884 20 2.49727 20C4.44748 20 8.08982 20 12.1429 20",
    stroke: "#4F4F4F",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2503 13C18.871 13 18.565 13.2803 18.5605 13.6277C17.6582 13.8992 17 14.6762 17 15.6008C17 15.9247 17.087 16.2276 17.2299 16.5013C17.594 17.199 18.359 17.6852 19.2503 17.6852C19.7284 17.6852 20.1173 18.0504 20.1173 18.4992C20.1173 18.9487 19.7284 19.3139 19.2503 19.3139C18.7716 19.3139 18.3828 18.9487 18.3828 18.4992C18.3828 18.1483 18.0735 17.8644 17.6914 17.8644C17.3092 17.8644 17 18.1483 17 18.4992C17 19.4244 17.6584 20.2014 18.5607 20.473C18.5656 20.8201 18.8712 21.1 19.2503 21.1C19.6295 21.1 19.9353 20.8201 19.94 20.4729C20.8418 20.2013 21.5 19.4243 21.5 18.4992C21.5 17.3504 20.4906 16.4155 19.2503 16.4155C18.7716 16.4155 18.3828 16.0503 18.3828 15.6008C18.3828 15.1519 18.7716 14.7868 19.2503 14.7868C19.7284 14.7868 20.1173 15.1519 20.1173 15.6008C20.1173 15.9517 20.4265 16.2357 20.8086 16.2357C21.1908 16.2357 21.5 15.9517 21.5 15.6008C21.5 14.6763 20.8419 13.8995 19.9402 13.6278C19.9396 13.5794 19.9219 13.5362 19.9101 13.4909C19.8374 13.2117 19.5769 13 19.2503 13Z",
    fill: "#4F4F4F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 7.5,
    r: 1.5,
    stroke: "#4F4F4F",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5H15.5",
    stroke: "#4F4F4F",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.5H9.5",
    stroke: "#4F4F4F",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 13.5,
    r: 1.5,
    stroke: "#4F4F4F",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.5H15.5",
    stroke: "#4F4F4F",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjustmentSettingsIcon);
export default __webpack_public_path__ + "static/media/AdjustmentSettingsIcon.ff28e1129a0440bffb92afceacd48f4b.svg";
export { ForwardRef as ReactComponent };